// 引入采购履约相关路由
import performanceRoutes from '@/router/performance/performance'

export default [performanceRoutes]
